let BlockView = require('views/block/base-block-view');
let ef = require('ef/ef');

let customMethods = {
  'exit-page-customization': {
    getModel() {
      return ef.customizations.get('exit-page-customization');
    },
    play() {
      if(ef.modules.completedModuleCount() === ef.modules.length) {
        this.modal = $('#custom-exit');
        this.modal.modal('show');
      }
    }
  }
};

var CustomizationView = BlockView.extend({
  initialize: function() {
    this.methods = customMethods[this.model.get('customization_type')];
    this.model = this.methods.getModel() || this.model;
    BlockView.prototype.initialize.apply(this, arguments);
  },
  getTemplateFunction() {
    return require('/views/block/customization/templates/' + this.model.get('type'));
  },
  play: function() {
    this.methods.play();
    this.readyToGo();
  }
});

module.exports = CustomizationView;
